export default __webpack_public_path__ + "static/media/subscription_ar.5327c46e.svg";